<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Tax and Payments</h1>
                    <p class="auth-subtext">Please provide your tax details to ensure compliance with IRS regulations and accurate tax reporting</p>
                </div>
            </div>
            
                  <el-form class="full_page" :model="formsData.userForm" :rules="formsData.userForm.rules"
                :ref="el => formsData.userForm.ref = el" :label-position="'top'" @submit.prevent="goNext('userForm')">
                  <!-- <div class="form_text">
                    <div class="text">
                        Please provide your tax details to ensure compliance with IRS regulations and accurate tax reporting
                    </div>
                </div> -->
                <el-form-item  prop="corporation_name" label="Please enter your corporation name">
                    <el-input v-model="formsData.userForm.corporation_name.value" autocomplete="off" placeholder="Business Name" />
                </el-form-item>
                <el-form-item class="no-scroll" prop="record_corporation_details" :required="true" label="Do you wish you record your corporation details?">
                    <el-select class="corporation-select" style="width: 100%" popper-class="normal-select"
                        v-model="formsData.userForm.record_corporation_details.value" placeholder="Please select">
                        <el-option label="Yes" :value="1"></el-option>
                        <el-option label="No" :value="0"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item prop="employer_identification_number" :required='true' label="Enter your Employer Identification Number" v-if="formsData.userForm.record_corporation_details.value === 1">
                    <input type="text" class="el-input el-input__inner"
                        :ref='el => formsData.userForm.employer_identification_number.ref = el'
                        :value="formsData.userForm.employer_identification_number.value" :placeholder="'000 - 0000000'"
                        v-imask="formsData.userForm.employer_identification_number.mask"
                        @accept="onFormMaskAccept($event, 'userForm', 'employer_identification_number')"
                        @blur="checkFormValidation('userForm', true, 'employer_identification_number')">
                </el-form-item>
                <el-form-item prop="tax_payer_identification_number" :required='true' label="Enter your Individual Tax Payer Identification Number" v-if="formsData.userForm.record_corporation_details.value === 1">
                    <input type="text" class="el-input el-input__inner"
                        :ref='el => formsData.userForm.tax_payer_identification_number.ref = el'
                        :value="formsData.userForm.tax_payer_identification_number.value" :placeholder="'000 - 0000000'"
                        v-imask="formsData.userForm.tax_payer_identification_number.mask"
                        @accept="onFormMaskAccept($event, 'userForm', 'tax_payer_identification_number')"
                        @blur="checkFormValidation('userForm', true, 'tax_payer_identification_number')">
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue" @click="goNext('userForm')" :disabled="isButtonDisabled">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import {
    onMounted,
    inject,
    computed
} from 'vue';

import {
    addIcons
} from 'ionicons'
import {
    arrowBackOutline
} from 'ionicons/icons'
addIcons({
    'arrow-back-outline': arrowBackOutline
})
import {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
} from '@ionic/vue';

import {
    useStore
} from 'vuex'

import {
    useRouter,
    useRoute
} from 'vue-router'
import formHooks from '@/hooks/form/form'
import formValidate from '@/hooks/form/validate/validate'
import formMasks from '@/hooks/form/mask/mask'
import { ElMessageBox } from "@/components/Vendor/Element";

import IMaskDirective from '@/directives/vue-imask/directive';

export default {
    components: {
        IonToolbar,
        IonButton,
        IonButtons,
        IonIcon,
    },
    directives: {
        imask: IMaskDirective
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject('setPageClassGlobal');
        const userData = $store.getters.GET_USER_DATA;
        console.log("🚀 ~ setup ~ userData:", userData)
        const formsDataArray = {
            userForm: {
                 corporation_name: {
                    ref: null,
                    value: userData.settings.corporationName || '',
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'corporationName', callback, setFormValidation);
                        },
                    
                    }]
                },
                record_corporation_details: {
                    ref: null,
                    value: userData.settings.recordCorporationDetails || '',
                    valueImportant: true,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'recordCorporationDetails', callback, setFormValidation);
                        },
                    }]
                },
                employer_identification_number: {
                    value: userData.settings.employerIdentificationNumber || '',
                    mask: formMasks.identificationNumber,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'identificationNumber', callback, setFormValidation);
                        },
                    }]
                },
                tax_payer_identification_number: {
                    value: userData.settings.taxPayerIdentificationNumber || '',
                    mask: formMasks.identificationNumber,
                    validators: [{
                        validator: (rule, formField, callback) => {
                            formValidate.validate(rule, formField, 'identificationNumber', callback, setFormValidation);
                        },
                    }]
                },
            }
        };

        const goBack = () => {
            $router.push({
                name: 'auth_tax_and_payments'
            })
        };
        const isButtonDisabled = computed(() => {
            if(formsData.userForm.record_corporation_details.value === 0 && formsData.userForm.corporation_name.value) {
                return false;
            }
            return formsData.userForm.disabled;
        });

        const goNext = (formName) => {
            $store.dispatch('addAuthPageBack', $route.name);
            formsRefs[formName].value.validate((valid) => {
                if (valid) {
                    (async () => {
                        try {
                            let formValues = getFormValues(formName);
                            formValues = {
                                    ...formValues,
                                    onboarding_step: "tax_payments_corp"
                                };
                            if(formValues.record_corporation_details === 0) {
                                // remove taxed_as if tax_has_corporation is 0
                                delete formValues.employer_identification_number;
                                delete formValues.tax_payer_identification_number;
                            }

                            await $store.dispatch('SAVE_USER_DATA', formValues);

                            if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                                    $store.dispatch("SAVE_USER_DATA", {
                                        survey: 1,
                                        hideLoading: true,
                                    });
                                    $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                                    $router.push({
                                        name: "intro",
                                    });
                                }else{
                                $router.push({
                                    name: 'auth_health_plan_and_benefits',
                                });
                            }

                          

                        } catch (error) {
                            console.error('Error submitting form:', error);
                        }
                    })();
                } else {
                    setFormValidation(formName, false, false);
                    console.log('error submit!!');
                    return false;
                }
            });
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    $store.dispatch('addAuthPageBack', $route.name);
                    if (userData.role === 'locum' && (userData.contractorOnboarding)) {
                    $store.dispatch("SAVE_USER_DATA", {
                        survey: 1,
                        hideLoading: true,
                    });
                    $store.dispatch("CONTRACTOR_ONBOARDING_COMPLETE");
                    $router.push({
                        name: "intro",
                    });
                    }else{
                        $router.push({
                            name: 'auth_health_plan_and_benefits',
                        })
                    }
                    
                } catch (error) {
                    console.log(error);
                }
            })();
          
        }

        onMounted(() => {
            setPageClassGlobal('global_auth_page');
            setFormRefs();
            formsRefs.userForm.value.$el[0].focus();
            checkFormValidation('userForm', false);
        });


        const {
            onFormMaskAccept,
            checkFormValidation,
            setFormValidation,
            getFormValues,
            setFormRefs,
            formsData,
            formsRefs,
        } = formHooks(formsDataArray);

        return {
            formsData,
            onFormMaskAccept,
            checkFormValidation,
            goBack,
            goNext,
            isButtonDisabled,
            skip
        }
    },
}
</script>